module.exports = __webpack_public_path__ + "static/media/RollCall_Main.12364e28.png";